import { getTranslate } from '@/utils/api-interceptors'
import ExpanableContent from '../ExpanableContent'

interface InformationType {
  description: {
    vi: string
    en: string
  }
  className?: string
  full?: boolean
  hideTitle?: boolean
}

export const ProductInformation = ({
  description,
  className,
  full = false,
  hideTitle = false,
}: InformationType) => {
  return (
    <ExpanableContent
      content={getTranslate(description)}
      title={!hideTitle ? 'Thông tin sản phẩm' : ''}
      full={full}
      className={className}
    />
  )
}

export default ProductInformation
